/**
 * iOS and Android apps expose headers and auth token
 * that can be used to make authenticated ajax calls. It does this by exposing it
 * to `window.Mobile.appEnv`.
 *
 * To make sure that JS components
 * wait until this is ready, A callback mechanism is exposed to allow components
 * to listen for when this information is ready.
 *
 * @see MobileHttpInterceptorService
 * */
window.Mobile = window.Mobile || {};

let _appEnv = {};
let _isAppEnvSet = false;
let _callbacks = [];

/**
 * Get the environment by looking at the mobile environment agent
 * injected via <meta> tag ONLY if `window.MobileAgent` isn't set
 * */
export const setMobileEnvironmentFlag = () => {
  if (window.MobileAgent) {
    return;
  }

  const metaElem = document.querySelector(
    'meta[data-name="native-mobile-agent"]'
  );
  let agent;
  if (metaElem && metaElem.getAttribute('data-content')) {
    agent = metaElem.getAttribute('data-content');
  } else {
    agent = 'web';
  }
  if (/^android.*/.test(agent)) {
    window.MobileAgent = 'android';
  } else if (/^ios.*/.test(agent)) {
    window.MobileAgent = 'ios';
  } else {
    window.MobileAgent = agent;
  }
};

function executeCallback(func) {
  func(_appEnv);
}

/**
 * Allows callbacks to be added to get notified at the moment the env variable
 * is set by the native mobile apps
 * */
export const addMobileEnvReadyCallback = (func) => {
  if (typeof func === 'function') {
    if (!_isAppEnvSet) {
      _callbacks.push(func);
    } else {
      executeCallback(func);
    }
  }
};

// if the appEnv is already defined, then immediately set the flags to indicate
// that the appEnv is ready so any callbacks attached afterward are executed immediately
// https://github.com/grnhse/greenhouse-ios/blob/225bf5b4d70847ac25cb3c8d7794eab9cc7a2913/Recruiting/Recruiting/controllers/WebViewController.swift#L33
// https://github.com/grnhse/greenhouse-android/blob/507c4ffd13fb886157b06fece934e3cdbcb05c7c/app/src/main/java/io/greenhouse/recruiting/ui/web/WebViewHelper.java#L72
if (typeof window.Mobile.appEnv !== 'undefined') {
  _isAppEnvSet = true;
  _appEnv = window.Mobile.appEnv;
} else {
  // otherwise, define the property and watch for mobile apps trying to set the value
  Object.defineProperty(window.Mobile, 'appEnv', {
    enumerable: true,
    configurable: false,
    get: function () {
      return _appEnv;
    },
    set: function (obj) {
      _appEnv = obj;

      // execute callbacks and pass it the env obj
      for (let i = 0; i < _callbacks.length; i++) {
        executeCallback(_callbacks[i]);
      }

      // clear all callbacks as they aren't needed
      _callbacks = [];
    },
  });
}

// for easy testing
window.Mobile.resetAppEnv = function () {
  _appEnv = {};
  _isAppEnvSet = false;
  _callbacks = [];
};
